export const DEFAULT = 'home';
export const MENU = 'drawer';
export const CHAT = 'chat';
export const AD = 'posting';
export const SHOW_REDDOT_WISHLIST = 'showRedDotOnWishlist';
